import physicsWaves from "./paths/cambridgePhysicsWaves";
import chemistryStatesOfMatter from "./paths/cambridgeChemistryStatesOfMatter";

const PATHS = [physicsWaves, chemistryStatesOfMatter];

const norm = (value) => String(value || "").trim().toLowerCase();

const isCambridgeDb = (contentDb) => {
  const db = norm(contentDb);
  return db.includes("igcse") || db.includes("igsce") || db.includes("cambridge");
};

export function resolveChapterLearningPath({ contentDb, subjectName, chapterName } = {}) {
  if (!isCambridgeDb(contentDb)) return null;
  const subject = norm(subjectName);
  const chapter = norm(chapterName);
  return (
    PATHS.find(
      (path) => norm(path.subject) === subject && norm(path.chapter) === chapter
    ) || null
  );
}

export { PATHS as CHAPTER_LEARNING_PATHS };
